import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import { normalizeChannelIds } from '../../utils/module-order-utils';

export interface ChannelOption {
  id: string;
  title: string;
}

interface CategoryChannelSelectProps {
  moduleKey: string;
  selectedChannelIds: number[];
  channels: ChannelOption[];
  onChange: (moduleKey: string, channelIds: number[]) => void;
}

export function CategoryChannelSelect({
  moduleKey,
  selectedChannelIds,
  channels,
  onChange,
}: CategoryChannelSelectProps) {
  const channelTitles = new Map(channels.map((channel) => [channel.id, channel.title]));
  const selectedValues = selectedChannelIds.map(String);

  function handleChange(event: SelectChangeEvent<string[]>) {
    const value = event.target.value;
    const nextValues = typeof value === 'string' ? value.split(',') : value;
    onChange(moduleKey, normalizeChannelIds(nextValues));
  }

  return (
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel id={`channel-select-${moduleKey}`}>Välj kanaler</InputLabel>
      <Select
        multiple
        labelId={`channel-select-${moduleKey}`}
        value={selectedValues}
        label="Välj kanaler"
        onChange={handleChange}
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
        renderValue={(selected) => selected.map((id) => channelTitles.get(id) ?? id).join(', ')}
      >
        {channels.map((channel) => (
          <MenuItem key={channel.id} value={channel.id}>
            {channel.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
